import { FetchMethod, useCodeerApi } from "../useCodeerApi"
import { Response, FileBadgeData, FileAttachmentScope } from "@/types"

export interface FileUploadResponse {
  original_name: string
  content_type: string
  size?: number
  file_url?: string
  uuid?: string
  error_msg?: string
  scope: FileAttachmentScope
  meta?: FileBadgeData["meta"]
}

/**
 * Transforms a FileUploadResponse to FileBadgeData
 * @param response The file upload response from the API
 * @returns A FileBadgeData object with the file information
 */
export const fileUploadResponseToFileBadgeData = (
  response: FileUploadResponse
): FileBadgeData => {
  // Validate and format the UUID properly
  const uuid =
    typeof response.uuid === "string"
      ? response.uuid.trim()
      : String(response.uuid || "")

  // Get the formatted file URL, ensuring it's properly formed
  const url = response.file_url || ""

  return {
    id: uuid || "",
    uuid: uuid || "",
    url: url || "",
    name: response.original_name || "",
    type: response.content_type || "",
    meta: response.meta,
    scope: response.scope || FileAttachmentScope.Persistent,
    status: "uploaded",
  }
}

export const useFileUploadApi = () => {
  return useCodeerApi<Response<FileUploadResponse>, FormData>(
    "/retrieval/upload-file",
    FetchMethod.Post
  )
}
